import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page1() {
  useEffect(() => {
    document.title = "Маяк — Сценарий"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page98" />
        <ForwardLink href="/page1" />
      </div>

      <p style={{ textAlign: "right" }}>ii.</p>
      <p><b>ДЕЙСТВУЮЩИЕ ЛИЦА:</b></p>
      <p>
        МОЛОДОЙ, новый помощник смотрителя маяка с грязным прошлым.<br/>
        СТАРИК, суровый смотритель маяка. Его начальник.
      </p>
      <br/>
      <p><b>СЕТТИНГ:</b></p>
      <p>Где-то далеко от побережья штата Мэн. Около 1890 года.</p>
      <br/>
      <p><b>ПРИМЕЧАНИЕ:</b></p>
      <p>Этот фильм <i>должен</i> быть снят на 35мм черно-белый негатив.</p>
      <p>Соотношение сторон: 1.19:1</p>
      <p>Аудио микс: Моно</p>
      <p style={{ textAlign: "right" }}>ii.</p>

      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page98" />
        <ForwardLink href="/page1" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1707340639/the-lighthouse-script/ons5lyv8iq1kjkqg12gs.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page1;
